module.exports = __webpack_public_path__ + "img/delete-icon-ai-styles.0a0c98cd.svg";